"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetTransacEmailContentEvents {
    static getAttributeTypeMap() {
        return GetTransacEmailContentEvents.attributeTypeMap;
    }
}
GetTransacEmailContentEvents.discriminator = undefined;
GetTransacEmailContentEvents.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "time",
        "baseName": "time",
        "type": "string"
    }
];
exports.GetTransacEmailContentEvents = GetTransacEmailContentEvents;
//# sourceMappingURL=getTransacEmailContentEvents.js.map